<div class="savings">
  <div class="grid-x grid-margin-x">
    <div class="cell large-6">
      <i class="icon-wallet-money"></i>
      <div class="flip-container flip-horizontal" [class.open]="showForm">
        <div class="flipper">
          <div class="card front" [attr.aria-hidden]="showForm" [style.height.px]="cardMinHeight">
            <h3 [innerHTML]="textkeyPrefix + '.headline.cost.savings' | translate: textPlaceholder"></h3>
            <p [innerHTML]="textkeyPrefix + textkeyCostSavings | translate: textPlaceholder"></p>
            <button [tabindex]="!showForm ? 0 : -1" (click)="showForm = !showForm" class="button hollow primary"><i class="icon-edit-3"></i><span [innerHTML]="textkeyPrefix + '.button.cost.savings' | translate"></span></button>
          </div>
          <div class="card back" #backCard [attr.aria-hidden]="!showForm" [style.display]="!showForm? 'none' : 'block'">
            <button type="button" class="close" [attr.aria-label]="'arialabel.close' | translate" (click)="showForm = !showForm"><i class="icon-x" [title]="textkeyPrefix + '.close' | translate"></i></button>
            <p [innerHTML]="textkeyPrefix + '.text.electricity.price' | translate"></p>
            <div role="alert" class="form-errors" *ngIf="formError" [innerHTML]="textkeyPrefix + '.error.' + formError | translate"></div>
            <form [formGroup]="form">
              <ng-container *ngFor="let field of formConfig.getFields()">
                <div formfield [invalidIfEmpty]="false" [inlineHelp]="true" [showInlineHelp]="false" [form]="form" [formModel]="field" [formConfig]="formConfig" [step]="textkeyPrefix" class="formfield {{field.type}} {{field.classes}}" *ngIf="field.isActive()"></div>
              </ng-container>
            </form>
            <button (click)="saveForm()" class="button hollow primary" [class.loading]="loading" [innerHTML]="textkeyPrefix + '.button.cost.save' | translate"></button>
          </div>
        </div>
      </div>
    </div>
    <div class="cell large-6">
      <i class="icon-co2"></i>
      <div class="card co2-savings" [style.height.px]="cardMinHeight">
        <h3 [innerHTML]="textkeyPrefix + '.headline.co2.savings' | translate: textPlaceholder"></h3>
        <p  [innerHTML]="textkeyPrefix + textkeyCo2Savings | translate: textPlaceholder"></p>
        <a role="button" class="button hollow primary inline-arrow-right" *ngIf="url" [href]="url" target="_blank" [innerHTML]="textkeyPrefix + '.button.co2.savings' | translate"></a>
      </div>
    </div>
  </div>
</div>
